import { constants } from "@newsela/angelou";

export const inheritStrokeCss = {
  root: {
    path: {
      fill: constants.colors.ui.neutral[700],
    },
  },
};
